import { Link } from "react-router-dom";
import { useCartStore } from "../store/cartStore";
import { useWishlistStore } from "../store/wishlistStore";

export const BottomNavBar = ({ onSearchOpen }) => {
  const isLoggedIn = !!localStorage.getItem("Token");
  const cartItemsCount = useCartStore(
    (state) =>
      state.cartData?.items_count ?? state.cartData?.items?.length ?? 0,
  );

  const wishlistCount = useWishlistStore(
    (state) => state.wishlist?.length ?? 0,
  );

  return (
    <div
      className="tf-toolbar-bottom type-1150"
      style={{ bottom: 0, paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="toolbar-item">
        <Link to="/shop">
          <div className="toolbar-icon">
            <i className="icon-shop" />
          </div>
          <div className="toolbar-label">Shop</div>
        </Link>
      </div>
      <div className="toolbar-item">
        <Link onClick={onSearchOpen}>
          <div className="toolbar-icon">
            <i className="icon-search" />
          </div>
          <div className="toolbar-label">Search</div>
        </Link>
      </div>
      <div className="toolbar-item">
        <Link to={isLoggedIn ? "/my-account" : "/login"}>
          <div className="toolbar-icon">
            <i className="icon-account" />
          </div>
          <div className="toolbar-label">Account</div>
        </Link>
      </div>
      <div className="toolbar-item">
        <Link to="/my-account/wishlist">
          <div className="toolbar-icon">
            <i className="icon-heart" />
            {wishlistCount > 0 && (
              <div className="toolbar-count">{wishlistCount}</div>
            )}
          </div>
          <div className="toolbar-label">Wishlist</div>
        </Link>
      </div>
      <div className="toolbar-item">
        <Link to="/cart">
          <div className="toolbar-icon">
            <i className="icon-bag" />
            {cartItemsCount > 0 && (
              <div className="toolbar-count">{cartItemsCount}</div>
            )}
          </div>
          <div className="toolbar-label">Cart</div>
        </Link>
      </div>
    </div>
  );
};
